import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { DateTime } from 'luxon';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { RangeKey } from '@common/enum';
import { DatesService } from '@common/services';

import { PopupRangeService } from '../../../utils/popup-range.service';
import { DateUtilities, PopupRangeStore } from '../../../utils';

@Component({
    selector: 'aa-popup-button',
    templateUrl: './popup-button.component.html',
    standalone: false
})
export class PopupButtonComponent implements OnInit
{
    @Input() rangeKey: RangeKey;
    @Output() buttonClicked: EventEmitter<string> = new EventEmitter<string>();
    public text: string;
    public isPressed: Observable<boolean> = of(false);
    private rkSince: DateTime;
    private rkUntil: DateTime;

    constructor (
        private popupRangeService: PopupRangeService
    )
    {

    }

    ngOnInit (): void
    {
        const { since, until } = DatesService.preRangeDatesStatic(RangeKey[this.rangeKey]);

        this.text = `RANGEKEYS.${this.rangeKey}`;
        this.rkSince = (since < this.popupRangeService.minDate ? this.popupRangeService.minDate : since).startOf('day');
        this.rkUntil = (until > this.popupRangeService.maxDate ? this.popupRangeService.maxDate : until).endOf('day');
        this.isPressed = this.popupRangeService.rangeConfig
            .pipe(
                map((prs: PopupRangeStore) =>
                    DateUtilities.isEqual(this.rkSince, prs.currentSince) && DateUtilities.isEqual(this.rkUntil, prs.currentUntil)
                )
            );
    }

    onClick = () =>
    {
        // this.isPressed = of(true);
        this.buttonClicked.emit(this.rangeKey);
    };
}
